import React from "react";
import { Image, Table, Tag, Popconfirm, Button } from "antd";
import { ColumnType } from "antd/es/table";
import { RiDeleteBin6Line } from "react-icons/ri";

import MyPagination from "../../components/Pagination";
import { ISubAdminPayload } from "../../../types/api/subAdmin";
import { FiEdit3 } from "react-icons/fi";
import { renderIcon, renderTableText } from "../../../lib/utils";
import BuildingsCard from "../../components/reuseComp/BuildingsCard";
import { useNavigate } from "react-router-dom";


interface SubAdminTableProps {
  data?: ISubAdminPayload[];
  handleDelete?: (id: string) => void;
  loading?: boolean;
  DEFAULT_NUQS_CONFIG?: any;
  qData?: any;
  refetch?: any;
}

const EditIcon = renderIcon(FiEdit3);
const DeleteIcon = renderIcon(RiDeleteBin6Line);


const SubAdminTable: React.FC<SubAdminTableProps> = ({
  data = [],
  handleDelete = () => {},
  loading = false,
  DEFAULT_NUQS_CONFIG,
  qData,
  refetch,
}) => {
 

  const navigate = useNavigate()


  const columns: ColumnType<ISubAdminPayload>[] = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render : (v) => renderTableText(v)
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render : (v) => renderTableText(v)
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      render : (v) => renderTableText(v)
    },
    {
      title: "Rights",
      dataIndex: "rights",
      key: "right",
      render : (v) => <div>{v?.map((item:string)=> <Tag color="blue">{item}</Tag>)}</div>
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status: boolean) => (
        <Tag color={status ? "green" : ""} bordered>
          {status ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      align: "right",
      render: (_: any, data: any) => (
        <div className="flex items-center justify-end gap-3">
          <EditIcon
            className="cursor-pointer text-primary text-[20px]"
            onClick={() => navigate(`/sub-admin/edit/${data?._id}`)}
          />

          <Popconfirm
            title="Are you sure to delete this row?"
            onConfirm={() => handleDelete?.(data?._id)}
            okText="Yes"
            cancelText="No"
          >
            <DeleteIcon className="cursor-pointer text-primary hover:text-red-600 text-[20px]" />
          </Popconfirm>
        </div>
      ),
    },
  ];

 return (
  <div>

    {/* Desktop Table (visible on md+) */}
    <div className="hidden md:block">
      <Table
        dataSource={data || []}
        columns={columns}
        rowKey={(item: any) => item?._id}
        pagination={false}
        size="middle"
        bordered={false}
        loading={loading}
        className="custom-table-class rounded-lg border border-gray-200 shadow-md"
         footer={() => <MyPagination qData={qData} onChange={refetch} total={qData.total} DEFAULT_NUQS_CONFIG={DEFAULT_NUQS_CONFIG} />}
      />
    </div>

    {/* Mobile Cards (visible below md) */}
    <div className="grid gap-4 md:hidden">
      {data?.map((data) => (
        <BuildingsCard
          key={data?._id}
          data={data}
          handleDelete={handleDelete}
        />
      ))}
    </div>
  </div>
);

};

export default SubAdminTable;
